/**
 * Bluetooth headsets often start muted until the link is up, then fire unmute.
 * A built-in mic that is already live can lag a moment before mute is set.
 */
export function readTrackMuted(track?: MediaStreamTrack): Promise<boolean> {
  if (!track) {
    return Promise.resolve(false);
  }

  const waitMs = track.muted ? 500 : 150;
  const waitEvent = track.muted ? 'unmute' : 'mute';

  return new Promise((resolve) => {
    const finish = () => {
      clearTimeout(timeoutId);
      track.removeEventListener(waitEvent, finish);
      resolve(track.muted);
    };

    const timeoutId = setTimeout(finish, waitMs);
    track.addEventListener(waitEvent, finish);
  });
}
